import React, { useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { Checkbox, Chip, Divider, Grid } from "@mui/material";
import { BASE_URL } from "../../../global";
import { toast } from "react-toastify";
import { DatasheetContext } from "./datasheet.context.js";
import { ClassicTable } from "../../../utils/components/Styles.js";
import axiosWithToken from "../../../utils/components/axiosTokenConfig.js";

const checkboxOptions = ["✔", "NA"];

export const onSubmitOpinionAndAnalysis = async (
  analysisSelectedOption,
  datasheetId,
) => {
  try {
    let payload = {
      ...analysisSelectedOption,
      datasheetId: Number(datasheetId),
      certificateId: Number(datasheetId),
    };

    if (analysisSelectedOption?.id) {
      await axiosWithToken
        .patch(
          BASE_URL + `opinionAndAnalysis/${analysisSelectedOption?.id}`,
          payload,
        )
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          if (err.message !== "request_aborted") {
            toast.error("error : ", err);
          }
        });
    } else {
      await axiosWithToken
        .post(BASE_URL + `opinionAndAnalysis`, payload)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          if (err.message !== "request_aborted") {
            toast.error("error : ", err);
          }
        });
    }
    return true;
  } catch (error) {
    // Handle errors
    console.error("Error in onSubmit:", error);
    return false;
  }
};

const OpinionAndAnalysisTable = ({ datasheetId }) => {
  const datasheetContextValue = useContext(DatasheetContext);
  const {
    state: { analysisSelectedOption, settings },
    dispatch,
  } = datasheetContextValue;

  const handleChangeForCheckbox = (event, keyName) => {
    const newValue = event.target.checked
      ? event.target.value === "✔"
        ? true
        : false
      : "";

    analysisSelectedOption[keyName] = newValue;
    dispatch({
      field: "analysisSelectedOption",
      value: analysisSelectedOption,
    });
  };

  const convertToBooleanOrEmpty = (value) => {
    if (value === "1") return true;
    if (value === "") return "";
    return false;
  };

  const getOpinionAndAnalysisList = () => {
    let url = BASE_URL;
    const payload = {
      query: `SELECT * FROM opinionAndAnalysis WHERE datasheetId = ${datasheetId}`,
    };
    axiosWithToken
      .post(url + "dynamic", payload)
      .then((res) => {
        if (res.data.length > 0) {
          const parsedData = {
            ...res.data[0],
            accepted: convertToBooleanOrEmpty(res.data[0].accepted),
            limitedUse: convertToBooleanOrEmpty(res.data[0].limitedUse),
            calibrated: convertToBooleanOrEmpty(res.data[0].calibrated),
            rejected: convertToBooleanOrEmpty(res.data[0].rejected),
            decsionRule1: convertToBooleanOrEmpty(res.data[0].decsionRule1),
            decsionRule2: convertToBooleanOrEmpty(res.data[0].decsionRule2),
            decsionRule3: convertToBooleanOrEmpty(res.data[0].decsionRule3),
          };

          dispatch({
            field: "analysisSelectedOption",
            value: parsedData,
          });
          // setAnalysisSelectedOption(parsedData);
        }
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  useEffect(() => {
    getOpinionAndAnalysisList();
  }, []);

  const decisionRuleItems = [
    {
      key: "decsionRule1",
      label: "Error is within manufacturer specification or IS Standard or customer specification then it is termed as Pass/Fail.",
    },
    {
      key: "decsionRule2",
      label: "Error measurement + Uncertainty is within manufacturer specification then it is termed as Pass/Fail.",
    },
    {
      key: "decsionRule3",
      label: "No Decision Rule or No conformity statement (Accept/Reject).",
    },
  ];
  // Inside your component, add this function
  const handleDecisionRuleChange = (event, keyName) => {
    const newValue = event.target.checked ? true : false;
    // update state for only decision rule
    analysisSelectedOption[keyName] = newValue;
    dispatch({
      field: "analysisSelectedOption",
      value: { ...analysisSelectedOption },
    });
  };


  return (
    <div>
      {settings?.["Opinion And Analysis Table"] === "true" && (
    <div>
          <Divider sx={{ my: 2 }}>
            <Chip
              label="Opinion And Analysis Table"
              variant="outlined"
              sx={{ fontSize: "1.1rem", fontWeight: "bold" }}
            />
          </Divider>
      <Grid container spacing={2} sx={{ mb: 3, width: "unset", mx: 0 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "8px",
          }}
        >
          <Typography
            sx={{
              width: "50%",
              textAlign: "left",
              typography: { xs: "body1" },
            }}
          >
            Accepted - Pass
          </Typography>
          {checkboxOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={analysisSelectedOption?.accepted === (item === "✔")}
                  onChange={(event) =>
                    handleChangeForCheckbox(event, "accepted")
                  }
                  value={item}
                />
              }
              label={<Typography variant="body2">{item}</Typography>}
            />
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "8px",
          }}
        >
          <Typography
            sx={{
              width: "50%",
              textAlign: "left",
              typography: { xs: "body1" },
            }}
          >
            Calibrated
          </Typography>
          {checkboxOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={
                    analysisSelectedOption?.calibrated === (item === "✔")
                  }
                  onChange={(event) =>
                    handleChangeForCheckbox(event, "calibrated")
                  }
                  value={item}
                />
              }
              label={<Typography variant="body2">{item}</Typography>}
            />
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "8px",
          }}
        >
          <Typography
            sx={{
              width: "50%",
              textAlign: "left",
              typography: { xs: "body1" },
            }}
          >
            Limited Use (Refer - Result)
          </Typography>
          {checkboxOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={
                    analysisSelectedOption?.limitedUse === (item === "✔")
                  }
                  onChange={(event) =>
                    handleChangeForCheckbox(event, "limitedUse")
                  }
                  value={item}
                />
              }
              label={<Typography variant="body2">{item}</Typography>}
            />
          ))}
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "8px",
          }}
        >
          <Typography
            sx={{
              width: "50%",
              textAlign: "left",
              typography: { xs: "body1" },
            }}
          >
            Rejected - Fail
          </Typography>
          {checkboxOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={analysisSelectedOption?.rejected === (item === "✔")}
                  onChange={(event) =>
                    handleChangeForCheckbox(event, "rejected")
                  }
                  value={item}
                />
              }
              label={<Typography variant="body2">{item}</Typography>}
            />
          ))}
        </Grid>
      </Grid>
        </div>
      )}

      {settings?.["Decision Rule"] === "true" && (
        <>
        <Divider sx={{ my: 2 }}>
            <Chip
              label="Decision Rule"
              variant="outlined"
              sx={{ fontSize: "1.1rem", fontWeight: "bold" }}
            />
          </Divider>
          <Grid container spacing={2} sx={{ mb: 3, width: "unset", mx: 0 }}>
            {decisionRuleItems.map(({ key, label }) => (
              <Grid item xs={12} sm={12} md={12} lg={12} key={key}
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  border: "1px solid #ddd",
                  padding: "8px",
                }}
              >
                <Checkbox
                  checked={!!analysisSelectedOption?.[key]}
                  onChange={(e) => handleDecisionRuleChange(e, key)}
                />
                <Typography sx={{ textAlign: "left" }}>{label}</Typography>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  );
};

export default OpinionAndAnalysisTable;
